import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuthorization } from '../contexts/AuthorizationContext';
import styles from './UnauthorizedPage.module.scss';

const UnauthorizedPage: React.FC = () => {
  const location = useLocation();
  const { getActivePrivileges, getActiveRoles } = useAuthorization();
  
  const from = location.state?.from?.pathname || '/';
  const activePrivileges = getActivePrivileges();
  const activeRoles = getActiveRoles();

  return (
    <div className={styles.unauthorizedPage}>
      <div className={styles.container}>
        <div className={styles.icon}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        
        <h1 className={styles.title}>Acceso No Autorizado</h1>
        
        <p className={styles.message}>
          No tienes permisos para acceder a esta página.
        </p>
        
        <div className={styles.details}>
          <p>Página intentada: <strong>{from}</strong></p>
          
          {activeRoles.length > 0 && (
            <div className={styles.roles}>
              <h3>Roles Activos:</h3>
              <ul>
                {activeRoles.map(role => (
                  <li key={role}>{role}</li>
                ))}
              </ul>
            </div>
          )}
          
          {activePrivileges.length > 0 && (
            <div className={styles.privileges}>
              <h3>Privilegios Activos:</h3>
              <ul>
                {activePrivileges.map(privilege => (
                  <li key={privilege}>{privilege}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
        
        <div className={styles.actions}>
          <Link to="/" className={styles.button}>
            Ir al Inicio
          </Link>
          
          <button 
            onClick={() => window.history.back()} 
            className={`${styles.button} ${styles.secondary}`}
          >
            Volver
          </button>
        </div>
        
        <div className={styles.help}>
          <p>
            Si crees que esto es un error, contacta al administrador del sistema.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;


